export default {
	time_item_defaults: {
		time_items: [
			{
				code: 100,
				label: 'Load/Unload',
				phase_number: '',
				task: '',
				onsite: false,
				main: false
			},
			{
				code: 102,
				label: 'Travel',
				phase_number: '',
				task: '',
				onsite: false,
				main: false
			},
			{
				code: 103,
				label: 'Onsite',
				phase_number: '',
				task: '',
				onsite: true,
				main: true
			},
			{
				code: 110,
				label: 'Diving',
				phase_number: '',
				task: '',
				onsite: true,
				main: false
			},
			{
				code: 109,
				label: 'Wading',
				phase_number: '',
				task: '',
				onsite: true,
				main: false
			}
		]
	}
};

/**
 * NOTE: Crew positions will need to be updated both here and on the API
 * in RenderPacketController.php under the render_packet module for any updates
 * for proper value indexing
 * */
export const roles = {
	field_supervisor: 'Field Supervisor',
	dive_supervisor: 'Dive Supervisor',
	diver: 'Diver',
	standby_diver: 'Standby Diver',
	diver_standby_diver: 'Diver/Standby Diver',
	tender_standby_diver: 'Tender/Standby Diver',
	tender: 'Tender',
	team_member: 'Team Member'
};
